/* eslint-disable no-mixed-spaces-and-tabs */
import { useGetUserDetailsQuery } from '@/features/user/userApi';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import ToolbarDropdown from './ToolbarDropdown';
import { FIELDS, MS_GRAPH, USER } from '@/utils/emailHelper';

const UserDropdown = ({ onChange }) => {
	const account = useSelector((state) => state.msalAccount.account);
	const email = account?.username;

	const { data: userDetails, ...userQuery } = useGetUserDetailsQuery({ email }, { skip: !email });

	const fields = useMemo(() => {
		return FIELDS.filter(
			(field) =>
				field.value !== 'signature' && (field.type === USER || field.type === MS_GRAPH)
		).map((field) => {
			const value = field.type === USER ? userDetails?.[field.value] : email;
			const disabled =
				value == null ||
				(typeof value === 'object'
					? Array.isArray(value)
						? value.length === 0
						: Object.keys(value).length === 0
					: String(value ?? '').trim().length === 0);
			return {
				...field,
				disabled,
			};
		});
	}, [userDetails, email]);
	

	const getNodeValue = (event) => {
		const field = fields.find((v) => v.value === event.target.value);

		const templateAttr = `template-value="${field.type}.${field.value}"`;
		const value =
			field.type === USER
				? userDetails?.[field.value]
				: field.type === MS_GRAPH
				? account?.[field.value]
				: '';
		const fspValue = value.toString().toLowerCase().includes('fsp') ? value : `FSP ${value}`;
		let node = `<${field.node} ${templateAttr}>${
			field.label.toLowerCase().includes('fsp') ? fspValue : value
		}</${field.node}>`;
		if (field.node === 'a') {
			node = `<a ${templateAttr} href="${
				field.label.toLowerCase().includes('email') ? `mailto:${value}` : value
			}">${field.label.toLowerCase().includes('email') ? value : field.label}</a>`;
		} else if (field.node === 'img') {
			const isAvatar = field.label.toLowerCase().includes('avatar');
			if (isAvatar) {
				const img = new Image();
				img.src = value;

				img.onload = () => {
					const size = Math.max(img.naturalWidth, img.naturalHeight);
					const style = ` style="border-radius: 50%; width: ${size}px; height: ${size}px; object-fit: cover;"`;
					node = `<img ${templateAttr}${style} src="${value}" alt="${field.label}" />`;
					onChange(node);
				};

				img.onerror = () => {
					// Fallback in case image fails to load
					node = `<img ${templateAttr} style="border-radius: 50%; width: 100px; height: 100px; object-fit: cover;" src="${value}" alt="${field.label}" />`;
					onChange(node);
				};
				return;
			} else {
				node = `<img ${templateAttr} src="${value}" alt="${field.label}" />`;
			}
			// const style = field.label.toLowerCase().includes('avatar') ? ' style="border-radius: 50%;" ': '';
			// node = `<img ${style}src="${value}" />`;
		}

		onChange(node);
	};

	return (
		<>
			<ToolbarDropdown title={'user'} fields={fields} onChange={getNodeValue} />
		</>
	);
};

export default UserDropdown;
